module.exports = __webpack_public_path__ + "static/img/合作模式.5ecd95b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作模式.jpg
// module id = LMf4
// module chunks = 1